<template>
  <div class="driver-panel-2" :class="$store.state.theme">
    <fade-transition :duration="1500">
      <div v-if="showStaleWarning && !dismissing" class="stale-warning" @click="dismissStaleWarning">
        <div class="stale-btn" :class="{ 'bg-green': dismissing }">
          <i v-if="dismissing" class="fa fa-spinner fa-spin has-text-black" />
          <i v-else>{{ $t("click-here") }}</i>
        </div>
      </div>
    </fade-transition>

    <div class="wrapper no-scrollbar">
      <DriverPanelPassengerNew v-if="hasNewPassenger && !hideNewJobs" :transactions="newJobs" />

      <div v-if="nJobs > 1" class="toggle-btn">
        <button class="button is-white toggle" @click="toggleList">
          <i class="fa fa-chevron-down fa-lg" v-if="isTall" :key="1" />
          <i class="fa fa-chevron-up fa-lg" v-else :key="2" />
        </button>
      </div>

      <div class="header is-size-5" @click="updateTransactionsForDriver(false)">
        <div class="columns is-mobile">
          <div class="column tab is-half active-tab has-text-dark">

            <!-- if driver has outstanding remit due -->
            <!-- <i v-if="true" class="fa fa-exclamation-triangle has-text-black" style="margin-right:6px;" /> -->

            <!-- driver score: 1 = too many cancellations, 2 = not enough jobs completed, 3 = ok -->
            <span v-if="$store.getters.isDeliveryDriver" @click="explainDriverScore">
              <i v-for="i in 3" :key="i" class="fa fa-circle" :class="driverScore[i - 1]" style="margin-right:6px;" />
              <span v-if="driverCancelledSecondsAgo < 60 * 20" class="cancelled-time">
                <i class="fa fa-exclamation-triangle" />
                {{ driverCancelledAtPretty }}
              </span>
            </span>
            <span v-else :class="tabClass(' ongoing')" @click="setTab('ongoing')">
              {{ $t("logistics.ongoing") }}
            </span>
          </div>
          <!-- <div class="column tab">
            <span :class="tabClass('scheduled')" @click="setTab('scheduled')">
              {{ $t("logistics.scheduled") }}
            </span>
            <span v-show="hasScheduled" class="
                tag
                is-rounded is-medium is-warning
                has-text-link has-text-weight-semibold
              " @click="setTab('scheduled')">
              {{ hasScheduled }}
            </span>
          </div> -->
          <div class="column tab" @click="noRainAlert">
            <i class="fa fa-sun" />
          </div>
          <div class="column tab" @click="rainAlert">
            <i class="fa fa-cloud-rain" />
          </div>
        </div>
      </div>

      <div class="body">
        <div v-if="!nJobs">
          <!-- <StreetHail /> -->

          <!-- <a v-if="isWorking" class="bird-btn" @click="downloadSound">
            <img src="/img/home2/toucan.svg" />
          </a>
          <a ref="dl" href="/sounds/parrot.mp3" download="tuk_sound" hidden></a> -->

          <!-- <i class="fa fa-umbrella fa-2x bird-btn has-text-info" @click="rainAlert" /> -->

          <div v-show="rejectedCount" class="rejected link" @click="undoRejected">
            {{ rejectedCount }} {{ $t("profile.jobs") }}
          </div>
          <div style="padding-top: 15px">
            <div v-if="isWorking">
              <p class="cog-wrapper" @click="toggleCog">
                <i v-if="cog" class="fa fa-cog fa-spin" />
                <i v-else class="fa fa-spinner fa-spin" />
              </p>
              <p class="subtitle is-6 has-text-grey has-text-weight-medium">
                {{ $t("driver.waiting-for-jobs") }}
              </p>
            </div>
            <div v-else @click="startWorking">
              <p style="padding-top: 15px; font-size: 3em">
                <i class="fa fa-play-circle has-text-success pulse" />
              </p>
              <p>{{ $t("driver.click-to-start-working") }}</p>
            </div>
          </div>
        </div>
        <DriverPanel2JobList v-show="nJobs" :tab="tab" />
        <!-- <hr v-if="isTall && nJobs > 1" /> -->
      </div>
    </div>

    <DriverPanelScheduled v-if="tab === 'scheduled'" @closed="setTab('ongoing')" />

    <DriverHistoryModal />
    <DispatcherHistoryModal />

    <DriverWallet v-if="showWallet" :missingPaymentInfo="true" @close="showWallet = false" />
  </div>
</template>

<script>
import EventBus from "../eventBus";
import { sounds } from "../functions.js";

import DriverPanel2JobList from "@/components/DriverPanel2JobList.vue";
import DriverPanelPassengerNew from "@/components/DriverPanelPassengerNew.vue";
import DriverHistoryModal from "@/components/DriverHistoryModal.vue";
import DispatcherHistoryModal from "@/components/DispatcherHistoryModal.vue";
// import StreetHail from "@/components/StreetHail.vue";
import DriverPanelScheduled from "@/components/DriverPanelScheduled.vue";
import DriverWallet from "@/components/DriverWallet.vue";

export default {
  name: "DriverPanel2",
  components: {
    DriverPanel2JobList,
    DriverPanelPassengerNew,
    DriverPanelScheduled,
    DriverHistoryModal,
    DriverWallet,
    DispatcherHistoryModal,
    // StreetHail,
  },
  data() {
    return {
      hasNewPassenger: false, // bool for showing new passenger panel
      newJobs: null, // transactions to show in new passenger panel
      driverPollInterval: null,
      cog: false,
      isTall: false,
      acknowledged: {},
      isUpdating: false,
      tab: "ongoing",
      showWallet: false,
      dismissing: false,
    };
  },
  watch: {
    showStaleWarning() {
      if (!this.showStaleWarning) return;
      sounds("parrot");
      // var msg = `🙅🏻‍♀️📍Driver STALE location warning - ${this.$store.getters.realName}`;
      // this.sendSuperuserNotification(msg);
    },
  },
  computed: {
    hideNewJobs() {
      // always show new jobs if don't have an active job
      if (!this.$store.getters.driverHasActiveJobs) return false;
      // otherwise use driver settings
      return this.$store.state.driverSettingHideNewJobs;
    },
    driverCancelledSecondsAgo() {
      if (!this.$store.state.driverCancelledAt) return 9999999;
      var now = new Date();
      var driverCancelledAt = new Date(this.$store.state.driverCancelledAt);
      var driverCancelledSeconds = (now - driverCancelledAt) / 1000;
      return driverCancelledSeconds;
    },
    driverCancelledAtPretty() {
      var driverCancelledAt = new Date(this.$store.state.driverCancelledAt);
      return this.hhmmTime(driverCancelledAt);
    },
    driverScore() {
      var score3 = ["has-text-success", "has-text-success", "has-text-success"];
      var score2 = ["has-text-warning", "has-text-warning", "has-text-white"];
      var score1 = ["has-text-danger", "has-text-white", "has-text-white"];
      var driverStats = this.$store.state.driverStats;
      if (!driverStats) return score3;
      if (driverStats.recent_cancellations > 1) return score1;
      if (driverStats.recent_jobs < 5) return score2;
      return score3;
    },
    rejectedCount() {
      return this.$store.state.rejectedTransactions.length;
    },
    role() {
      return this.$store.getters.getDriverRole;
    },
    nJobs() {
      if (this.tab === "ongoing") {
        return this.$store.getters.getWorkerTransactionsStateConfirmed.length;
      } else {
        return this.$store.getters.getWorkerTransactionsStateScheduled.length;
      }
    },
    hasScheduled() {
      return this.$store.getters.getWorkerTransactionsStateScheduled.length;
      // var jobs = this.$store.getters.getOngoingWorkerTransactions
      // return jobs.length; //- this.nJobs;
    },
    isDispatcher() {
      return this.isWorkingDispatcher();
    },
    isWorking() {
      return this.$store.state.isWorking;
    },
    hasNewJobs() {
      // var transactions = this.$store.getters.getWorkerTransactionsStateNew;
      var newJobs = this.$store.getters.getDriverTransactionsStateNew;
      if (!newJobs || !newJobs.length) return false;
      if (this.blockNewJobs) return false;
      return true;
    },
    hasCancelledTransactions() {
      var cancelled = this.$store.getters.getWorkerTransactionsStateCancelled;
      if (cancelled.length > 0) return true;
      return false;
    },
    blockNewJobs() {
      // don't block new transactions if worker is dispatcher
      if (this.isWorkingDispatcher()) return false;
      // don't block if nearby drivers not set
      // var transactions = this.$store.getters.getWorkerTransactionsStateNew;
      var newJobs = this.$store.getters.getDriverTransactionsStateNew;
      if (!newJobs[0].data.nearby_drivers) return false;
      // don't block if driver doesn't have an ongoing job
      if (!this.$store.getters.driverHasOngoingPassengers) return false;
      // otherwise block any new transactions from appearing
      this.console("blocked New Transactions!!!");
      return true;
    },
    showStaleWarning() {
      // 2 different cases: delivery and transport
      // delivery: job in state enroute and userState.updated_at > 3 minutes old
      // transport: job in state confirmed and userState.updated_at > 2 minutes old
      var jobs = this.$store.getters.getWorkerTransactionsStateEnroute;
      if (!jobs.length) return false;
      var now = new Date();
      var locationUpdated = new Date(this.$store.state.userState.updated_at);
      var lastUpdated = (now - locationUpdated) / 1000;
      return lastUpdated > 120; // last updated n seconds ago
    },
  },
  created() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === "setTransactionsForWorker") {
        if (this.hasCancelledTransactions) {
          EventBus.$emit("CLOSE_PASSENGER_DETAIL", true);
        }
        this.checkAcknowledgeRequired();
        if (this.hasNewJobs) {
          this.updateDriversAutocomplete(); // only for dispatcher
          this.hasNewPassenger = true;
          // this.newTransactions = this.$store.getters.getWorkerTransactionsStateNew;
          this.newJobs = this.$store.getters.getDriverTransactionsStateNew;
          setTimeout(() => EventBus.$emit("DRIVER_FIT_LAYER"), 600);
        } else {
          this.hasNewPassenger = false;
        }
      }
    });
  },
  mounted() {
    EventBus.$on("OPEN_PASSENGER_DETAIL", () => this.toggleList("short"));

    EventBus.$on("DRIVER_LOADER", (on) => {
      if (on) this.isUpdating = true;
      else this.isUpdating = false;
    });

    EventBus.$on("SHOW_DRIVER_IGNORED_JOBS", () => {
      this.undoRejected();
    });

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") return;
      this.updateTransactionsForDriver(true); // force update transactions whenever driver comes to this page
    });
  },
  activated() {
    this.pollTransactions();
    this.updateTransactionsForDriver(true); // force update transactions whenever driver comes to this page
    this.showWallet = false;
  },
  deactivated() {
    this.showWallet = false;
  },
  beforeDestroy() {
    if (this.driverPollInterval) clearInterval(this.driverPollInterval);
  },
  methods: {
    dismissStaleWarning() {
      this.updateLocation();
      this.dismissing = true;
      setTimeout(() => (this.dismissing = false), 6000);
      sounds("mystery_long");
    },
    explainDriverScore() {
      var msg = `<div style='text-align:left'>
        🔴 = Too many cancellations<br>
        🟡🟡 = Okay<br>
        🟢🟢🟢 = Great!
        </div>`;
      this.infoToast(msg, "bottom", 6000);
    },
    noRainAlert() {
      var msg = `ส่งข้อความเข้ากลุ่ม LINE หากฝนหยุดตก`;
      this.infoToast(msg)
    },
    rainAlert() {
      // Is it raining? Please tell us where it is raining. // No Rain // Yes
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; color:blue; margin-bottom:12px'>
          <i class='fa fa-cloud-showers-heavy'></i>
          &nbsp;ฝนตกไหม?
        </p>
        <p>โปรดบอกเราว่าที่ไหนฝนตก</p>
        </div>`,
        input: "text",
        showCancelButton: true,
        cancelButtonText: "ไม่มีฝน",
        confirmButtonText: "<i class='fa fa-umbrella'></i>&nbsp;มีฝน",
        showCloseButton: true
      }).then((val) => {
        if (val.value) {
          var msg = `☔️ Rain Alert [${this.$store.getters.realName}] at [${val.value}]`;
          this.sendSuperuserNotification(msg);
          this.successToast("🙏🏼 ขอบคุณเราแจ้งทีมงานแล้ว", "top");
          if (this.isSoundOn()) sounds("parrot");
        }
      })
    },
    downloadSound() {
      sounds("parrot");
      var title = this.$t("squawk.title");
      var steps = this.$t("squawk.steps");
      var step1 = this.$t("squawk.1");
      var step2 = this.$t("squawk.2");
      var step3 = this.$t("squawk.3");
      var download = this.$t("squawk.download");
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px; font-size:1.3em'>
        <i class='fab fa-earlybirds'></i>&nbsp;${title}
        </p>
        <p style='margin-bottom:12px'><i>${steps}</i></p>
        <p>1. <i class='fa fa-download'></i>&nbsp;${step1}</p>
        <p>2. <i class='fa fa-folder-plus'></i>&nbsp;${step2}</p>
        <p>3. <i class='fa fa-cog'></i>&nbsp;${step3}</p></div>`,
        showCloseButton: true,
        confirmButtonText: `${download}&nbsp;<i class='fa fa-download'></i>`,
      }).then((val) => {
        if (val.value) {
          this.$refs.dl.click();
          var loader = this.loadingDots("cyan");
          setTimeout(() => {
            loader.hide();
            this.$swal({
              title: this.$t("success"),
              text: "tuk_sound.mp3 saved to downloads folder",
              showConfirmButton: false,
              showCloseButton: true,
              type: "success",
              timer: 6000,
            });
          }, 500);
        }
      });
    },
    tabClass(tabName) {
      if (this.tab === tabName) return "active-tab has-text-dark";
      return null;
    },
    setTab(tab) {
      this.tab = tab;
    },
    undoRejected() {
      this.$store.commit("undoRejectedTransactions");
      this.updateTransactionsForDriver(true);
    },
    startWorking() {
      if (this.isSoundOn()) sounds("mystery_short");
      EventBus.$emit("DRIVER_START_WORKING");
    },
    checkAcknowledgeRequired() {
      var txns = this.$store.getters.getWorkerTransactionsStateConfirmed;
      var t = txns.find(
        (t) =>
          t.data.hasOwnProperty("acknowledged") &&
          !t.data.acknowledged &&
          t.handled_by === this.userID() &&
          !this.acknowledged[t.id]
      );
      if (!t) return; // no transactions require acknowledgement
      var txt = this.$t("driver.please-acknowledge");
      this.$swal({
        title: `${this.$t("driver.new-dispatch")}<br>${txt}<br>👌🏼`,
        text: this.$t("driver.if-unable-cancel"),
      }).then(() => {
        this.acknowledged[t.id] = true;
        this.$store
          .dispatch("patchTransaction", {
            transactionID: t.id,
            data: { data: { acknowledged: true } },
          })
          .catch((err) => {
            this.acknowledged[t.id] = false;
            console.error("acknowledge dispatch", err);
          });
        this.thankYou();
      });
    },
    updateDriversAutocomplete() {
      if (!this.isWorkingDispatcher()) return; // only do for Dispatcher
      if (this.$store.getters.getWorkingRole) {
        var workflowID = this.$store.getters.getWorkingRole.workflow_id;
        this.$store
          .dispatch("autocompleteDriverWorkflows", workflowID)
          .catch((err) => console.error("updateDriversAutocomplete", err));
      }
    },
    toggleCog() {
      // if (this.cog) sounds("collect2");
      // else sounds("success");
      this.cog = !this.cog;
      this.updateTransactionsForDriver(false); // true
    },
    pollTransactions() {
      console.log("pollTransactions DriverPanel2");
      this.updateTransactionsForDriver(false); // trigger straight-away
      // then check if driver poll has been set up or not yet
      if (!this.driverPollInterval) {
        this.driverPollInterval = setInterval(() => {
          this.updateTransactionsForDriver(false); // re-trigger on interval
        }, 1000 * 30); // ping ever 10 seconds
      }
    },
    showHistory() {
      this.showWallet = true;
    },
    toggleList(size) {
      this.updateTransactionsForDriver(false);
      if (size === "short") {
        this.isTall == false;
        this.$el.querySelector(".cards").classList.remove("height-auto");
      } else {
        this.isTall = !this.isTall;
        this.$el.querySelector(".cards").classList.toggle("height-auto");
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  z-index: 1;
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: auto;
  min-height: 180px;
  max-height: calc(100vh - 150px);
  /* overflow: scroll; */
  width: 100%;
}

.dark .wrapper {
  background-color: #123;
  color: white;
}

.header {
  padding: 6px;
  background-color: #ddd;
  text-shadow: 0 0 2px #333;
  box-shadow: 0px -2px 2px rgba(100, 100, 100, 0.3);
}

.header .fa {
  text-shadow: 0 0 1px #333;
}

.column.tab {
  padding-right: 0;
}

.tab {
  color: rgba(128, 128, 128, 0.9);
  font-weight: 500;
}

.active-tab {
  font-weight: 600;
}

.tab:active {
  font-size: 1.1em;
}

@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
  }

  100% {
    box-shadow: 0 0 0 10px rgba(247, 211, 8, 0.5);
  }
}

.pulse {
  animation: shadow-pulse 1s infinite;
  border-radius: 50%;
}

.pulse-blue {
  animation: shadow-pulse-blue 1s infinite;
}

@keyframes shadow-pulse-blue {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 255, 255, 0.95);
  }

  100% {
    box-shadow: 0 0 0 5px rgba(0, 255, 255, 0.5);
  }
}

.toggle {
  padding: 8px;
  /* background-color: rgba(255, 255, 255, 0.9); */
  /* filter: drop-shadow(2px 2px 2px #666); */
}

.badge {
  z-index: 1;
  position: absolute;
  margin-top: -2px;
  margin-left: -8px;
  background-color: #ff3860 !important;
  border-radius: 50%;
  padding: 6px;
}

.rejected {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 12px;
  font-weight: 550;
  color: lightcoral;
  font-weight: 0.7em;
  animation: pulse-text 1.5s ease-out infinite;
}

@keyframes pulse-text {
  0% {
    text-shadow: 0 0 0 yellow;
  }

  50% {
    text-shadow: 0 0 14px yellow, 0 0 14px yellow, 0 0 14px yellow,
      0 0 14px yellow, 0 0 14px yellow, 0 0 14px yellow, 0 0 14px yellow,
      0 0 14px yellow, 0 0 14px yellow, 0 0 14px black;
  }

  100% {
    text-shadow: 0 0 0 yellow;
  }
}

.bird-btn {
  position: absolute;
  right: 25px;
  margin-top: 35px;
  padding: 12px 9px;
  /* background-color: rgba(255, 255, 255, 0); */
}

.bird-btn img {
  height: 35px;
  opacity: 0.5;
}

.toggle-btn {
  height: 0px;
  position: relative;
  top: 3px;
  /* top: -40px; */
}

.link {
  border-bottom: 1px #ccc dotted;
}

hr {
  margin: 0 0;
  border: 5px solid lightgrey;
}

.stale-warning {
  position: absolute;
  top: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(255, 192, 203, 0.5);
  z-index: 23;
}

.stale-btn {
  padding: 12px;
  background-color: red;
  color: white;
  /* margin: auto; */
  width: 50vw;
  top: 50vh;
  position: absolute;
  transform: translate(50%, -50%);
  border-radius: 100px;
  box-shadow: 1px 1px 5px black;
  font-size: 1.8em;
}

.bg-green {
  background-color: lightgreen;
}

.cog-wrapper {
  padding-top: 15px;
  font-size: 3em;
  color: #bbb;
}

.cancelled-time {
  background-color: white;
  border-radius: 4px;
  color: red;
  padding: 0 4px;
}
</style>